/*
 * Author: Roger
 * File Created: Wednesday, 24-09-04 06:10 pm
 * Last Modified: Friday, 24-09-13 05:52 pm, by Roger
 */

import { styled, Typography } from '@mui/material';

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '40px',
  fontWeight: 600,
  lineHeight: '120%',
  [theme.breakpoints.only('xs')]: {
    fontSize: '24px',
    display: 'inline',
    [`&:last-of-type`]: {
      marginLeft: '0.4em',
    },
  },
  [theme.breakpoints.only('sm')]: {
    fontSize: '28px',
  },
  [theme.breakpoints.only('md')]: {
    fontSize: '32px',
  },
}));
